/**
 * Prefix and suffix variables with 2 percentages. We replace these values during deployment
 */
export const environment = {
  production: true,
  apiUrl: '%%productionApi%%',
  appVersion: '%%version%%',
  conversationApi: '%%conversationApi%%',
  externalApi: '%%externalTableApi%%',
  patientListApiTest: 'https://wayfinder-aos-b7ftczhgazgwewe7.uksouth-01.azurewebsites.net',
  patientListApiProd: 'https://wayfinder.ebo.ai',
  patientListPluginUrl: '%%patientListPluginUrl%%',
  clientId: '%%productionClientId%%',
  xApiKey: '%%productionXApiKey%%',
  webchatFileName: '%%webchatFileName%%',
  translatorApiKey: '%%translatorApiKey%%',
  orgCode: '%%orgCode%%'
};
